// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blueink-sig-iframe {\n    display: block;\n    width: 100%;\n    height: 100%;\n    min-height: 480px;\n    min-width: 320px;\n    border: none;\n}", ""]);
// Exports
module.exports = exports;
